import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="countdown"
export default class extends Controller {
  static targets = ["countdown"];

  connect() {
    this.secondsUntilEnd = parseInt(
      this.countdownTarget.dataset.secondsUntilEndValue
    );

    const now = new Date().getTime();
    this.endTime = new Date(now + this.secondsUntilEnd * 1000);

    // Run once immediately to avoid the 1-second delay
    this.countdown();
    this.timer = setInterval(() => this.countdown(), 1000);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }

  countdown() {
    const now = new Date().getTime();
    const secondsRemaining = Math.max(0, (this.endTime - now) / 1000);

    if (secondsRemaining <= 0) {
      clearInterval(this.timer);
      this.countdownTarget.innerHTML = "Deal expired!";
      return;
    }

    const days = Math.floor(secondsRemaining / 86400);
    const hours = Math.floor((secondsRemaining % 86400) / 3600);
    const minutes = Math.floor((secondsRemaining % 3600) / 60);
    const seconds = Math.floor(secondsRemaining % 60);

    let displayString = "";

    // Logical branching based on your requirements
    if (days > 0) {
      displayString = `${days}d ${hours}h`;
    } else if (hours > 0) {
      displayString = `${hours}h ${minutes}m`;
    } else if (minutes > 0) {
      displayString = `${minutes}m ${seconds}s`;
    } else {
      displayString = `${seconds}s`;
    }

    this.countdownTarget.innerHTML = displayString;
  }
}
